import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled, { css } from 'foundations-theming/utils';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { tableButtonStyles } from 'deal-plans-lib/components/milestone/styledComponents/tableButtonStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditIconWrap = styled.span.withConfig({
  displayName: "DealPlanNameHoverButton__EditIconWrap"
})(["opacity:0;transition:opacity 150ms ease;"]);
const NameHoverButton = styled.button.withConfig({
  displayName: "DealPlanNameHoverButton__NameHoverButton"
})(["", ""], ({
  theme
}) => {
  return css(["align-items:center;background:transparent;border:none;display:flex;gap:", ";margin:0 -", ";border-bottom:2px solid transparent;padding:0 ", ";width:100%;", ":disabled:hover{background:transparent;}:not(:disabled):hover ", ",:not(:disabled):focus-visible ", "{opacity:1;}"], theme.space['200'], theme.space['100'], theme.space['100'], tableButtonStyles, EditIconWrap, EditIconWrap);
});
const DealPlanNameHoverButton = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(NameHoverButton, Object.assign({}, props, {
    children: [children, /*#__PURE__*/_jsx(EditIconWrap, {
      children: /*#__PURE__*/_jsx(EditIcon, {
        color: "text-primary-disabled"
      })
    })]
  }));
};
export default DealPlanNameHoverButton;